import { render } from "./AuthenticationPage.vue?vue&type=template&id=a06b26ec"
import script from "./AuthenticationPage.vue?vue&type=script&lang=js"
export * from "./AuthenticationPage.vue?vue&type=script&lang=js"

import "./AuthenticationPage.vue?vue&type=style&index=0&id=a06b26ec&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__